import React from 'react';

import { SubmissionButtons } from '@components/common';

import { IResultStatistic } from '@interfaces/import/import';

import styles from './SkippedFiles.module.scss';

interface ISkippedFilesProps {
	toggleSkippedFilesModal: () => void;
	importStatistic: IResultStatistic;
	handleDownloadReport: () => void;
}

const SkippedFiles = ({
	toggleSkippedFilesModal,
	importStatistic,
	handleDownloadReport,
}: ISkippedFilesProps) => {
	const skippedIds = importStatistic?.skippedIds.join(', ');

	return (
		<div className={styles.skippedFilesContainer}>
			<div className={styles.skipped}>
				{importStatistic.skipped}&nbsp;skipped item(s):
			</div>
			{!!skippedIds
				&& <div className={styles.ids}>
					{skippedIds}
				</div>
			}
			<SubmissionButtons
				negativeHandler={toggleSkippedFilesModal}
				negativeLabel='Close'
				positiveHandler={handleDownloadReport}
				positiveLabel='Download'
			/>
		</div>
	);
};

export default SkippedFiles;
